import React from "react";
import Slider from "react-slick";
import Styles from "./home.module.css";

const CardSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const cards = [
    { id: 1, title: "Card 1", content: "This is the content of Card 1." },
    { id: 2, title: "Card 2", content: "This is the content of Card 2." },
    { id: 3, title: "Card 3", content: "This is the content of Card 3." },
    { id: 4, title: "Card 4", content: "This is the content of Card 4." },
    { id: 5, title: "Card 5", content: "This is the content of Card 5." },
  ];

  return (
    <div className={Styles.cardslidercontainer}>
      <Slider {...settings}>
        {cards.map((card) => (
          <div key={card.id} className={Styles.testimonialscard}>
            <h3>{card.title}</h3>
            <p>{card.content}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CardSlider;
